/* eslint-disable no-useless-escape */
export default function checkJustNumberMath(number: string) {
  if (number === "") return true;
  return new RegExp(/^[0-9\.\-\/]+$/).test(number);
}
